import { useRef, useState } from "react"
import { IconButton } from "@mui/material"
import PauseIcon from "@mui/icons-material/Pause"
import PlayArrowIcon from "@mui/icons-material/PlayArrow"

type Props = {
  src: string
  testId?: string
}

/**
 * Compact play/pause icon for table rows. The underlying <audio> element has no
 * controls and uses preload="none", so the mp3 is fetched only on first play.
 */
export default function AudioPlayButton({ src, testId }: Props) {
  const audioRef = useRef<HTMLAudioElement | null>(null)
  const [playing, setPlaying] = useState(false)

  const toggle = () => {
    const audio = audioRef.current
    if (!audio) return
    if (audio.paused) {
      audio.play().catch(() => {})
    } else {
      audio.pause()
    }
  }

  return (
    <>
      <IconButton
        size="small"
        onClick={toggle}
        aria-label={playing ? "Pause audio" : "Play audio"}
        data-testid={testId}
      >
        {playing ? <PauseIcon fontSize="small" /> : <PlayArrowIcon fontSize="small" />}
      </IconButton>
      <audio
        ref={audioRef}
        src={src}
        preload="none"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
      />
    </>
  )
}
